const angular = require('angular');
const { MobilePhoneValidationSuccessComponentDefinition } = require('./mobile-phone-validation-success.component');
const { MobilePhoneValidationErrorComponentDefinition } = require('./mobile-phone-validation-error.component');

angular.module('wowApp.common')
    .component('wowMobilePhoneValidationSuccess', MobilePhoneValidationSuccessComponentDefinition)
    .component('wowMobilePhoneValidationError', MobilePhoneValidationErrorComponentDefinition)
    .directive('wowMobilePhoneValidator', require('./mobile-phone-validator.directive'))
    .directive('wowMobilePhoneVerification', ['Settings', '$window', 'ResourceInjector', require('./mobile-phone-verification.directive')]);



// WEBPACK FOOTER //
// ./src/common/mobilephonevalidator/index.js